import { CustomFieldOption } from 'types/customField';
import React from 'react';
import {
  BookmarkIcon,
  BookmarkSlashIcon,
  EllipsisVerticalIcon,
  TrashIcon as Trash,
} from '@heroicons/react/24/outline';
import { AutoSuggest } from '@teetsh/app/src/components/Form/AutoSuggest';
import ButtonGroup from '@teetsh/app/src/components/Form/ButtonGroup';
import { Menu as MenuComponent } from '@teetsh/app/src/components/Menu';
import {
  removeItemAtIndex,
  replaceItemAtIndex,
} from '@teetsh/app/src/utils/listMethods';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

interface Props {
  options: CustomFieldOption[];
  className?: string;
  value: string[];
  onChange: (v: string[]) => void;
  onCreateOption: (v: string) => void;
  onRemoveOption: (v: string) => void;
}

export function MultiselectCustomField(props: Props) {
  const {
    value: items,
    onChange,
    className,
    options,
    onCreateOption,
    onRemoveOption,
  } = props;
  const { t } = useTranslation(['common']);

  return (
    <div className={className}>
      {(items || []).concat('').map((item, index) => {
        const isItemInOptions = options.some(opt => opt.value === item);
        return (
          <div tw="relative mb-0.5 flex" key={index}>
            <div tw="flex-grow">
              <AutoSuggest
                onChange={newValue =>
                  onChange(replaceItemAtIndex(items, newValue, index))
                }
                value={item}
                options={options.map(opt => ({
                  value: opt.value,
                  label: opt.value,
                }))}
                placeholder={t(
                  'common:components.customFields.multiselect.inputPlaceholder',
                )}
              />
            </div>
            <ButtonGroup tw="ml-1">
              <MenuComponent portal>
                <MenuComponent.Button
                  minimal
                  iconSize="sm"
                  icon={EllipsisVerticalIcon}
                  css={[index >= items.length && tw`invisible`]}
                />
                <MenuComponent.Items size="auto">
                  <div>
                    {isItemInOptions ? (
                      <MenuComponent.Item
                        icon={BookmarkSlashIcon}
                        onClick={() => onRemoveOption(item)}
                        text={t(
                          'common:components.customFields.multiselect.removeOption',
                        )}
                      />
                    ) : (
                      <MenuComponent.Item
                        onClick={() => onCreateOption(item)}
                        icon={BookmarkIcon}
                        text={t(
                          'common:components.customFields.multiselect.createOption',
                        )}
                      />
                    )}
                  </div>
                  <div>
                    <MenuComponent.Item
                      onClick={() => onChange(removeItemAtIndex(items, index))}
                      icon={Trash}
                      intent="danger"
                      text={t(
                        'common:components.customFields.multiselect.removeValue',
                      )}
                    />
                  </div>
                </MenuComponent.Items>
              </MenuComponent>
            </ButtonGroup>
          </div>
        );
      })}
    </div>
  );
}
